import Swal from 'sweetalert2';

/**
 * 建立停用優惠券模板時的引用確認 HTML
 * @param {Array} references
 * @param {number} activeCount
 * @returns {string}
 */
export function buildDeactivateReferencesHtml(references = [], activeCount = 0) {
  const activeItems = references.filter((item) => item.isActive);
  const itemsToShow = activeItems.length > 0 ? activeItems : references.slice(0, 8);

  const listHtml = itemsToShow.map((item) => {
    const context = item.contextLabel ? `<div style="font-size:12px;color:#6b7280;margin-top:2px;">${item.contextLabel}</div>` : '';
    return `<li style="margin:8px 0;text-align:left;">
      <strong>${item.sourceTypeLabel}</strong>：${item.sourceName}
      <span style="margin-left:6px;font-size:12px;color:${item.isActive ? '#b45309' : '#6b7280'};">(${item.statusLabel})</span>
      ${context}
    </li>`;
  }).join('');

  const moreCount = references.length - itemsToShow.length;
  const moreHtml = moreCount > 0
    ? `<p style="margin:8px 0 0;font-size:13px;color:#6b7280;">另有 ${moreCount} 處引用未列出</p>`
    : '';

  const intro = activeCount > 0
    ? `此模板正被 <strong>${activeCount}</strong> 個進行中的流程引用，停用後這些流程將<strong>無法再自動發放</strong>此優惠券。`
    : '此模板仍被以下流程引用，停用後將無法再透過這些流程發放新券。';

  return `<div style="text-align:left;font-size:14px;line-height:1.6;color:#374151;">
    <p style="margin:0 0 12px;">${intro}</p>
    <ul style="margin:0;padding-left:20px;max-height:220px;overflow-y:auto;">${listHtml}</ul>
    ${moreHtml}
    <p style="margin:12px 0 0;color:#6b7280;font-size:13px;">已發放給會員的優惠券不受影響。</p>
  </div>`;
}

/**
 * 停用模板前確認（有引用時顯示清單）
 * @param {Array} references
 * @param {number} activeCount
 * @returns {Promise<boolean>}
 */
export async function confirmDeactivateWithReferences(references = [], activeCount = 0) {
  if (!references.length) {
    return Swal.fire({
      icon: 'warning',
      title: '確定要停用此模板？',
      text: '停用後將無法再發放新券，已發放的優惠券仍可使用。',
      showCancelButton: true,
      confirmButtonText: '確定停用',
      cancelButtonText: '取消',
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      reverseButtons: true
    }).then((result) => result.isConfirmed);
  }

  return Swal.fire({
    icon: 'warning',
    title: '確定要停用此模板？',
    html: buildDeactivateReferencesHtml(references, activeCount),
    showCancelButton: true,
    confirmButtonText: '仍要停用',
    cancelButtonText: '取消',
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#6c757d',
    reverseButtons: true,
    width: '560px'
  }).then((result) => result.isConfirmed);
}
